import React from 'react'

const EntertainmentHeaderIcon = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="entertainment-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(244, 67, 54, 1)" />
          <stop offset="100%" stopColor="rgba(211, 47, 47, 1)" />
        </linearGradient>
        <filter id="entertainment-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Film reel */}
      <circle cx="16" cy="16" r="10" stroke="url(#entertainment-grad)" strokeWidth="2" filter="url(#entertainment-glow)"/>
      <circle cx="16" cy="16" r="5" stroke="url(#entertainment-grad)" strokeWidth="2" filter="url(#entertainment-glow)"/>
      
      {/* Film holes */}
      <circle cx="16" cy="6" r="1.5" fill="url(#entertainment-grad)"/>
      <circle cx="16" cy="26" r="1.5" fill="url(#entertainment-grad)"/>
      <circle cx="6" cy="16" r="1.5" fill="url(#entertainment-grad)"/>
      <circle cx="26" cy="16" r="1.5" fill="url(#entertainment-grad)"/>
      
      {/* Diagonal film holes */}
      <circle cx="10" cy="10" r="1.2" fill="url(#entertainment-grad)" opacity="0.8"/>
      <circle cx="22" cy="10" r="1.2" fill="url(#entertainment-grad)" opacity="0.8"/>
      <circle cx="10" cy="22" r="1.2" fill="url(#entertainment-grad)" opacity="0.8"/>
      <circle cx="22" cy="22" r="1.2" fill="url(#entertainment-grad)" opacity="0.8"/>
      
      {/* Play symbol in center */}
      <path d="M14 13L20 16L14 19V13Z" fill="url(#entertainment-grad)" opacity="0.9"/>
      
      {/* Film strip */}
      <rect x="2" y="14" width="3" height="4" rx="0.5" fill="url(#entertainment-grad)" opacity="0.4"/>
      <rect x="27" y="14" width="3" height="4" rx="0.5" fill="url(#entertainment-grad)" opacity="0.4"/>
      
      {/* Sparkle effects */}
      <path d="M26 6L26.5 7L27 6.5L26.5 6L26 5L25.5 6L26 6.5L26.5 7L26 6Z" fill="url(#entertainment-grad)" opacity="0.7"/>
      <path d="M6 26L6.5 27L7 26.5L6.5 26L6 25L5.5 26L6 26.5L6.5 27L6 26Z" fill="url(#entertainment-grad)" opacity="0.7"/>
    </svg>
  )
}

export default EntertainmentHeaderIcon
